import {ModuleWithProviders, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewellPrompterComponent } from "./prompter/prompter.component";
import { MatDialogModule } from "@angular/material/dialog";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {NewellAlert} from "./alert";
import {MatButtonModule} from "@angular/material/button";



@NgModule({
  declarations: [ NewellPrompterComponent ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatSnackBarModule,
    MatButtonModule,
  ],
  exports: [ NewellPrompterComponent ],
})
export class NewellAlertModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: NewellAlertModule,
      providers: [ NewellAlert ]
    };
  }
}
